import type {
  Incident,
  MapIncident,
} from '../maritime-menu-options/incidents-panel/incident.model';

export const positionDefined = (incident: Incident): incident is MapIncident =>
  !!incident.position;
